import { options } from './constants'

export const getAccessabilityColorsFromColour = (color: string) => {
    const accessabilityColors = options.find(
        (option) => color.includes(option.classStr)
    );

return accessabilityColors;
}